import dayjs from "dayjs";

const ACTIVE_SUBSCRIPTION_STATUSES = new Set(["active", "trialing"]);
export const ACTIVATION_REDIRECT_STORAGE_KEY = "vintree_pending_activation_redirect";

export function hasActiveSubscription(profile) {
  if (!profile?.subscriptionExpiresAt) return false;
  if (
    profile?.subscriptionStatus &&
    !ACTIVE_SUBSCRIPTION_STATUSES.has(profile.subscriptionStatus)
  ) {
    return false;
  }
  return dayjs(profile.subscriptionExpiresAt).isAfter(dayjs());
}

export function hasPlanAccess(profile) {
  return Boolean(profile?.permissoesPlano?.plano) || hasActiveSubscription(profile);
}

export function hasStripeCustomer(profile) {
  return Boolean(profile?.stripeCustomerId);
}

export function isPaymentFailureIssue(profile) {
  return (
    profile?.subscriptionIssueCode === "payment_failed" ||
    profile?.subscriptionStatus === "past_due" ||
    profile?.subscriptionStatus === "unpaid"
  );
}
